import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Katrajtomumbaicabservice() {



  const cardData = {


  keyword: "Katraj to Mumbai Cab Service",

  headingDescription: "Trustline Cab provides dependable Katraj to Mumbai cab service with comfortable vehicles, professional chauffeurs, and affordable travel options for business trips, airport transfers, family travel, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, we ensure safe, punctual, and stress-free transportation with well-maintained cars. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to match every travel requirement. With transparent pricing, doorstep pickup, online booking, and 24/7 customer support, Trustline Travels is the trusted choice for Katraj to Mumbai taxi services.",

  topPlaces: [
    {
      title: "One International Center",
      description: "One International Center in Lower Parel is a premium corporate destination featuring multinational companies, financial institutions, and modern commercial offices."
    },
    {
      title: "Goregaon Business District",
      description: "Goregaon Business District is a growing commercial hub with IT companies, corporate offices, exhibition centers, and business parks."
    },
    {
      title: "Airoli IT Park",
      description: "Airoli IT Park is a major technology hub in Navi Mumbai, home to leading IT companies, software firms, and corporate campuses."
    },
    {
      title: "Millennium Business Park",
      description: "Millennium Business Park in Mahape is a well-known IT and business destination with technology companies and professional workspaces."
    },
    {
      title: "MIDC Andheri",
      description: "MIDC Andheri is a prominent industrial and commercial area with manufacturing units, IT firms, and corporate establishments."
    },
    {
      title: "Chhatrapati Shivaji Maharaj International Airport",
      description: "Mumbai Airport is a major aviation hub providing domestic and international connectivity with modern passenger facilities."
    },
    {
      title: "Colaba Causeway",
      description: "Colaba Causeway is a popular shopping and cultural destination known for street markets, cafés, handicrafts, and heritage charm."
    },
    {
      title: "Kanheri Caves",
      description: "Kanheri Caves are ancient Buddhist rock-cut monuments located inside Sanjay Gandhi National Park, showcasing Mumbai's rich history."
    },
    {
      title: "Worli Sea Face",
      description: "Worli Sea Face is a scenic coastal promenade offering beautiful Arabian Sea views and a relaxing atmosphere for visitors."
    },
    {
      title: "Nehru Planetarium",
      description: "Nehru Planetarium is a popular educational attraction featuring astronomy shows, science exhibits, and interactive learning experiences."
    }
  ],





"services": [
  {
    "name": "Katraj to Mumbai Cab Service",
    "description": "Book Katraj to Mumbai cab service for comfortable and reliable outstation travel with premium AC vehicles, experienced drivers, and affordable pricing. Available for airport transfers, corporate travel, family trips, and personal journeys. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs with doorstep pickup and flexible one-way or round-trip options."
  },
  {
    "name": "Katraj to Mumbai Cab",
    "description": "Hire Katraj to Mumbai cab for safe and smooth highway travel with clean vehicles and professional chauffeurs. Ideal for Mumbai airport drops, business meetings, railway station transfers, and long-distance travel."
  },
  {
    "name": "Katraj to Mumbai Taxi",
    "description": "Get Katraj to Mumbai taxi service with comfortable AC cars, transparent fares, and trained drivers. Book private taxis for one-way, round-trip, and outstation journeys."
  },
  {
    "name": "Katraj to Mumbai Taxi Fare",
    "description": "Check Katraj to Mumbai taxi fare with affordable rates for Sedan, Ertiga, Innova Crysta, and SUV vehicles. Transparent pricing helps customers plan their travel budget without hidden charges."
  },
  {
    "name": "Katraj to Mumbai Airport Cab",
    "description": "Book Katraj to Mumbai Airport cab for punctual airport pickup and drop service. Enjoy comfortable seating, luggage support, and professional drivers for domestic and international airport transfers."
  },
  {
    "name": "Katraj to Mumbai Airport Cab Fare",
    "description": "Get affordable Katraj to Mumbai Airport cab fare with flexible vehicle options and transparent pricing for airport travel requirements."
  },
  {
    "name": "Katraj to Navi Mumbai Cab",
    "description": "Reserve Katraj to Navi Mumbai cab for business and personal travel with comfortable vehicles, experienced drivers, and reliable doorstep pickup."
  },
  {
    "name": "Katraj to Mumbai One Way Cab",
    "description": "Book Katraj to Mumbai one way cab for economical single-side travel without return charges. Suitable for airport drops, relocation, and business trips."
  },
  {
    "name": "Katraj to Dadar Cab",
    "description": "Hire Katraj to Dadar cab for convenient Mumbai city travel with affordable pricing, clean cars, and professional drivers."
  },
  {
    "name": "Ambegaon Pune to Mumbai Cab",
    "description": "Book Ambegaon Pune to Mumbai cab service for comfortable outstation travel with AC vehicles, doorstep pickup, and experienced chauffeurs."
  },
  {
    "name": "Ambegaon Budruk to Mumbai Airport Cab",
    "description": "Get Ambegaon Budruk to Mumbai Airport cab for hassle-free airport transfers with timely pickup, luggage assistance, and reliable service."
  },
  {
    "name": "Dhayari to Mumbai Cab",
    "description": "Hire Dhayari to Mumbai cab for safe and comfortable travel with private vehicles, affordable fares, and professional drivers."
  },
  {
    "name": "Dhayari to Mumbai Taxi Service",
    "description": "Book Dhayari to Mumbai taxi service for airport transfers, business travel, and family journeys with Sedan, Ertiga, and Innova Crysta options."
  },
  {
    "name": "Mukund Nagar to Mumbai Cab",
    "description": "Reserve Mukund Nagar to Mumbai cab for reliable transportation with clean cars, experienced drivers, and flexible travel plans."
  },
  {
    "name": "Parvati to Mumbai Cab",
    "description": "Book Parvati to Mumbai cab service for comfortable long-distance travel with affordable fares and professional chauffeur service."
  },
  {
    "name": "Sinhagad Road to Mumbai Cabs",
    "description": "Get Sinhagad Road to Mumbai cabs for private and comfortable travel with multiple vehicle options suitable for families and corporate passengers."
  },
  {
    "name": "Cab Service in Katraj Pune",
    "description": "Cab service in Katraj Pune provides local taxi, airport transfer, corporate travel, and outstation cab solutions with Sedan, Ertiga, Innova Crysta, and SUV vehicles."
  },
  {
    "name": "Online Cab Booking in Katraj",
    "description": "Book online cab booking in Katraj with quick confirmation, easy reservation, transparent pricing, and reliable vehicles for local and outstation travel."
  },
  {
    "name": "Safe & Reliable Cabs in Katraj",
    "description": "Book safe and reliable cabs in Katraj with verified drivers, clean vehicles, affordable pricing, and comfortable travel experience."
  },
  {
    "name": "Innova Crysta on Rent in Katraj Pune",
    "description": "Hire Innova Crysta on rent in Katraj Pune for premium family trips, airport transfers, corporate travel, and outstation journeys with spacious seating."
  },
  {
    "name": "Ertiga on Rent in Katraj",
    "description": "Book Ertiga on rent in Katraj for comfortable group travel with affordable rates, AC facility, and professional drivers."
  },
  {
    "name": "Sedan Car on Rent in Katraj",
    "description": "Hire Sedan car on rent in Katraj for business travel, airport transfers, and personal trips with comfortable AC vehicles."
  },
  {
    "name": "Katraj to Mumbai Airport Cabs",
    "description": "Choose Katraj to Mumbai Airport cabs for timely airport transfers with reliable drivers, luggage space, and smooth travel experience."
  },
  {
    "name": "Velocity Cabs Pune",
    "description": "Velocity Cabs Pune offers premium Pune Mumbai cab services, airport transfers, corporate transportation, and outstation travel with quality vehicles."
  },
  {
    "name": "Cab Service in Pune",
    "description": "Our cab service in Pune provides reliable local taxi, airport cab, corporate travel, and long-distance outstation transportation solutions."
  },
  {
    "name": "Pune Mumbai Cab",
    "description": "Affordable Pune Mumbai cab service for airport transfers, business trips, family travel, and one-way journeys with professional drivers."
  },
  {
    "name": "Katraj to Mumbai Cab Booking",
    "description": "Book Katraj to Mumbai cab booking online with easy confirmation, flexible pickup options, and multiple vehicle choices."
  },
  {
    "name": "Cab from Katraj to Mumbai",
    "description": "Hire cab from Katraj to Mumbai for private and comfortable travel with experienced drivers and well-maintained vehicles."
  },
  {
    "name": "Katraj to Mumbai Car Rental",
    "description": "Choose Katraj to Mumbai car rental service for chauffeur-driven vehicles suitable for airport travel, business meetings, and family trips."
  },
  {
    "name": "Cheap Katraj to Mumbai Cab",
    "description": "Affordable Katraj to Mumbai cab service offering budget-friendly fares, comfortable vehicles, and dependable travel solutions."
  },
  {
    "name": "Book Katraj to Mumbai Cab Online",
    "description": "Book Katraj to Mumbai cab online with quick confirmation, transparent fares, and trusted outstation cab service."
  },
  {
    "name": "Katraj to Mumbai Outstation Cab",
    "description": "Katraj to Mumbai outstation cab service provides safe highway travel with experienced drivers and comfortable private vehicles."
  },
  {
    "name": "24x7 Katraj to Mumbai Taxi Service",
    "description": "24x7 Katraj to Mumbai taxi service available anytime for airport transfers, emergency travel, corporate trips, and family journeys."
  },
  {
    "name": "Best Katraj to Mumbai Cab Service",
    "description": "Choose the best Katraj to Mumbai cab service with reliable vehicles, professional drivers, transparent pricing, and excellent customer support."
  }
],

"tableData": [
  ["Katraj to Mumbai Cab Service", "Katraj to Mumbai Cab"],
  ["Katraj to Mumbai Taxi", "Katraj to Mumbai Taxi Fare"],
  ["Katraj to Mumbai Airport Cab", "Katraj to Mumbai Airport Cab Fare"],
  ["Katraj to Navi Mumbai Cab", "Katraj to Mumbai One Way Cab"],
  ["Katraj to Dadar Cab", "Ambegaon Pune to Mumbai Cab"],
  ["Ambegaon Budruk to Mumbai Airport Cab", "Dhayari to Mumbai Cab"],
  ["Dhayari to Mumbai Taxi Service", "Mukund Nagar to Mumbai Cab"],
  ["Parvati to Mumbai Cab", "Sinhagad Road to Mumbai Cabs"],
  ["Cab Service in Katraj Pune", "Online Cab Booking in Katraj"],
  ["Safe & Reliable Cabs in Katraj", "Innova Crysta on Rent in Katraj Pune"],
  ["Ertiga on Rent in Katraj", "Sedan Car on Rent in Katraj"],
  ["Katraj to Mumbai Airport Cabs", "Velocity Cabs Pune"],
  ["Cab Service in Pune", "Pune Mumbai Cab"],
  ["Katraj to Mumbai Cab Booking", "Cab from Katraj to Mumbai"],
  ["Katraj to Mumbai Car Rental", "Cheap Katraj to Mumbai Cab"],
  ["Book Katraj to Mumbai Cab Online", "Katraj to Mumbai Outstation Cab"],
  ["24x7 Katraj to Mumbai Taxi Service", "Best Katraj to Mumbai Cab Service"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Katraj to Mumbai Cab Service",
    WhyChoosedescription: "Trustline Cab provides comfortable Katraj to Mumbai cab services with reliable pickups, professional drivers, and smooth long-distance travel."
  },
  {
    WhyChooseheading: "Convenient Pickup from Katraj",
    WhyChoosedescription: "Get doorstep pickup from Katraj, Ambegaon, Dhayari, Narhe, Bibwewadi, and nearby Pune areas."
  },
  {
    WhyChooseheading: "Experienced Drivers for Highway Routes",
    WhyChoosedescription: "Our skilled chauffeurs ensure safe and comfortable travel through Pune-Mumbai highways with proper route knowledge."
  },
  {
    WhyChooseheading: "Affordable & Clear Fare Details",
    WhyChoosedescription: "Enjoy competitive cab pricing with transparent billing and no hidden charges during your Katraj to Mumbai journey."
  },
  {
    WhyChooseheading: "Wide Range of Comfortable Cars",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for individual or group travel."
  },
  {
    WhyChooseheading: "One Way & Round Trip Booking",
    WhyChoosedescription: "Select one-way cabs, return trips, or customized travel options based on your travel requirements."
  },
  {
    WhyChooseheading: "Airport & Outstation Travel Support",
    WhyChoosedescription: "Our services include Mumbai Airport transfers, business travel, family trips, and long-distance outstation journeys."
  },
  {
    WhyChooseheading: "Quick Booking Assistance",
    WhyChoosedescription: "Get instant quotations and fast booking confirmation with support from our dedicated travel team."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Katraj to Mumbai Cab Service?",
    answer: "Yes, Trustline Cab offers reliable Katraj to Mumbai cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Katraj to Mumbai?",
    answer: "Yes, we provide affordable one-way cab services from Katraj to Mumbai with flexible pickup options."
  },
  {
    question: "Which vehicles are available for Katraj to Mumbai travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for different passenger requirements."
  },
  {
    question: "Do you provide pickup from nearby Katraj locations?",
    answer: "Yes, pickup is available from Katraj, Ambegaon Budruk, Dhayari, Narhe, Bibwewadi, and surrounding areas."
  },
  {
    question: "Can I book a cab from Katraj to Mumbai Airport?",
    answer: "Yes, we provide direct cab services from Katraj to Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless mentioned in the booking quotation."
  },
  {
    question: "Is Katraj to Mumbai cab service available 24 hours?",
    answer: "Yes, Trustline Cab provides cab services throughout the day and night for convenient travel."
  },
  {
    question: "Can I reserve my cab in advance?",
    answer: "Yes, advance booking is recommended to confirm vehicle availability and preferred pickup timing."
  },
  {
    question: "Do you provide cabs for family and group travel?",
    answer: "Yes, we offer spacious vehicle options like Ertiga, Innova, Innova Crysta, and Tempo Travellers for families and groups."
  },
  {
    question: "How can I book a Katraj to Mumbai cab with Trustline Travels?",
    answer: "Share your pickup location, travel date, destination, and preferred vehicle details to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Deepak Shinde",
    feedback: "I booked a cab from Katraj to Mumbai for a family visit. Trustline Travels provided a comfortable vehicle, polite driver, and a smooth journey throughout the route.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Snehal Patil",
    feedback: "The Katraj to Mumbai cab service was very convenient. Pickup was on time, the car was clean, and the driver ensured a safe and relaxing travel experience.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Katraj to Mumbai Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/katraj-to-mumbai-cab.webp",
  "description": "Book Katraj to Mumbai cab service for safe, comfortable, and affordable intercity travel. Trustline Travels offers one-way, round-trip, airport transfers, and private taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5746"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/katraj-to-mumbai-cab"
  }
};




  return (
    <div>

<Helmet>
  <title>Katraj to Mumbai Cab Service | Airport Taxi Booking | +91 8087080034</title>

  <meta
    name="description"
    content="Book Katraj to Mumbai cab service with Trustline Travels for affordable one-way, round-trip, and airport transfers. Get Sedan, Ertiga, SUV, Innova, and Innova Crysta taxis with safe drivers and 24x7 online booking."
  />

  <meta
    name="keywords"
    content="katraj to mumbai airport cab fare, katraj to mumbai navi mumbai cab, ambegaon pune to mumbai cab, ambegaon budruk to mumbai airport cab, dhayari to mumbai cab, mukund nagar to mumbai cab, Parvati to Mumbai Cab, Sinhagad Road to Mumbai Cabs, katraj to mumbai one way cab, dhayari to mumbai taxi service, Cab Service in Katraj, online cab booking in katraj, Book Safe Katraj to Mumbai Cab, katraj to mumbai taxi, katraj to mumbai airport taxi, pune to mumbai cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/52.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Katrajtomumbaicabservice;